import { Flex, Box } from "@chakra-ui/react";
import BackButton from "src/components/BackButton";
import StopButton from "src/modules/station/components/StopButton";
import AvatarPicker from "../AvatarPicker";
import CameraPicker from "src/components/CameraPicker";
import IconAsButton from "src/components/IconAsButton";
import { ReactComponent as SettingsIcon } from "src/icons/menu.svg";
import { ReactComponent as RotateCameraIcon } from "./rotatecamera-outlined.svg";

export default function ControllingPanel({
  isConnected,
  openSettings,
  onAvatarChange,
  stopBroadcasting,
  openCameraList,
  closeCameraList,
  renderCameraList,
  cameraList,
  handleCameraChange,
  selectedCameraId
}) {
  const settingsIcon = (
    <IconAsButton
      icon={SettingsIcon}
      fill="white"
      size="20px"
      onClick={openSettings}
    />
  );

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      height="38px"
      position="relative"
    >
      <Box position="fixed" top="7px" left="50%" transform="translate(-50%)">
        <AvatarPicker onAvatarChange={onAvatarChange} />
      </Box>
      <Flex alignItems="center">
        {isConnected ? (
          settingsIcon
        ) : (
          <BackButton goTo="/dashboard" fill="white" />
        )}
        {cameraList && cameraList.length > 1 && (
          <IconAsButton
            onClick={openCameraList}
            ml="24px"
            icon={RotateCameraIcon}
            fill="white"
            size="20px"
          />
        )}
      </Flex>
      {cameraList && cameraList.length > 1 && (
        <CameraPicker
          isOpen={renderCameraList}
          onClose={closeCameraList}
          cameraList={cameraList}
          handleCameraChange={handleCameraChange}
          selectedCameraId={selectedCameraId}
          left={145}
        />
      )}
      {isConnected ? <StopButton onClick={stopBroadcasting} /> : settingsIcon}
    </Flex>
  );
}
